// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@hardwoods/XDL/types";
import { color } from "@hardwoods/XDL/Utilities";
import { xScreen } from "@hardwoods/XDL/Utilities/MediaQuery";
import { styledScrollbar } from "@hardwoods/XDL/Utilities/SharedStyles";
import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import { MenuPresentationProps } from "@insite/mobius/Menu";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...BreadcrumbsPresentationPropsDefault,
        typographyProps: {
            size: 12,
            color: "text.main",
            css: css`
                letter-spacing: 0;
                line-height: 26px;

                ${xScreen.lte("sm")} {
                    &,
                    & > ${TypographyStyle} {
                        font-size: 11px;
                    }
                }
            `,
        },
        css: css`
            > ${IconWrapper}, > ${StyledButton}, > nav[class^="MenuWrapper"] {
                margin-right: 20px;
                &${IconWrapper} {
                    margin-left: -10px;
                    margin-right: 10px;
                    &:last-child {
                        display: none;
                    }
                }
                &:last-child {
                    margin-right: 0;
                }
            }

            ${xScreen.lte("sm")} {
                > ${IconWrapper}, > ${StyledButton}, > nav[class^="MenuWrapper"] {
                    margin-right: 12px;
                    &${IconWrapper} {
                        margin-left: -4px;
                        margin-right: 12px;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];

// 3 dots menu style
export const breadcrumbsMenuStyle: MenuPresentationProps = {
    cssOverrides: {
        wrapper: css`
            flex: 0 1 auto;
            min-width: 0;
            cursor: pointer;
            width: 20px;

            // up-arrow icon
            &:hover::after {
                content: "";
                position: absolute;
                top: 10px;
                left: 6px;
                margin-left: -10px;
                border-width: 10px;
                border-style: solid;
                border-color: transparent transparent ${color("common.white")} transparent;
                z-index: 1355;
            }
            // to prevent hide Menu when a user move mouse from elment to menu
            &:hover::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 30px;
                background: transparent;
                box-shadow: none;
            }

            ul {
                overflow-y: auto;
                ${styledScrollbar(4)}
                a:hover:before {
                    height: 0;
                }
            }
        `,
        menu: css`
            left: -30px;
            top: 30px;
            width: 181px;
            border-radius: 3px;
            background-color: ${color("common.white")};
            box-shadow: ${getProp("theme.shadows.3")};
            border: 1px solid ${color("primary", 0.05)};

            max-height: 216px;
        `,
        menuItem: css`
            width: 100%;
            &:hover,
            a:hover {
                background: ${color("common.ui2", 0.5)};
            }
            a span {
                font-size: 15px;
                letter-spacing: 0;
                line-height: 32px;
            }
        `,
    },
};
